export const color = {
    darkBlue: '#0e2f5a',
    blue: '#0078ff',
    lightBlue: '#51a3ff',
    lighterBlue: '#95e1f5',
    orange: '#ff620c',
    lightOrange: '#fd9c2b',
    lightGreen: '#20b832',
    green: '#20b832',
    darkGreen: '#008710',
    lightRed: '#f77b72',
    red: '#f44235',
    darkRed: '#f13328',
    purple: '#a904b6',
    teal: '#13a5aa',
    lime: '#cddc39',
    pink: '#f16191',
    yellow: '#fddc00',
    brown: '#ad5610',
    gray: '#90a0b3',
    cyan: '#00edeb',
    olive: '#817801',
    white: '#ffffff',
    gray00: '#ffffff',
    gray20: '#fafafa',
    gray40: '#e4ebf1',
    gray50: '#c6d1db',
    gray60: '#90a0b3',
    gray70: '#5a616a',
    gray80: '#323a45',
    gray90: '#262c35',
    gray100: '#000000',
    black: '#000000',
};
//# sourceMappingURL=color.js.map